import React, { useEffect, useState } from 'react'
import './Testimonials.scss';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import moment from 'moment';
import Select from "react-select";
import styled from '@emotion/styled';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import { CircularProgress, Switch } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableSortLabel from '@mui/material/TableSortLabel';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import { FormGroup, Label} from "reactstrap";
import { useSelector, useDispatch } from 'react-redux';
import {stableSort, rowOptions, testimonialsoptions} from '../../../utils/Helper'
import {getTestimonialListAction, updateTestimonialStatusAction} from '../../../redux/actions/ReportAction/TestimonialsAction/TestimonialsAction'
import { createNotification } from '../../../Config/NotificationToast';
import ReadMore from '../../../components/ReadMore';
import DatePicker from '../../../components/DatePicker/DatePicker';
import { tabKeys } from '../../../Config/Constant';


const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order, orderBy) => {
    if (orderBy === "duration") orderBy = "durationOne"
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
    {
        id: 'program_title',
        disablePadding: true,
        label: 'PROGRAM TITLE',
        width: '20%',
        disableSorting: false,
    },
    {
        id: 'guest_name',
        disablePadding: false,
        label: 'GUEST NAME',
        width: '20%',
        disableSorting: false,
    },
    {
        id: 'check_in',
        disablePadding: false,
        label: 'CHECK IN / CHECK OUT',
        width: '20%',
        disableSorting: false,
    },
    {
        id: 'submitted_on',
        disablePadding: false,
        label: 'SUBMITTED ON',
        width: '20%',
        disableSorting: false,
    },
    {
        id: 'status',
        disablePadding: false,
        label: 'STATUS',
        width: '10%',
        disableSorting: false,
    },
    {
        id: 'mark',
        disablePadding: false,
        label: 'MARK',
        width: '10%',
        disableSorting: true,
    },
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) =>
                (<TableCell
                    key={headCell.id}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                    sx={{width: headCell.width}}
                >
                    <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.disableSorting}
                        disabled={headCell.disableSorting}
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { pageNos, rowsPerPageNos, setShowLoader, activeTab } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');
    const [fromDate, setFromDate] = useState(searchParams.get('filter_from') || moment().startOf('month').format('YYYY-MM-DD'));
    const [toDate, setToDate] = useState(searchParams.get('filter_to') || moment().format('YYYY-MM-DD'));

    useEffect(() => {
        if (activeTab == tabKeys.reports.TESTIMONIALS) {
            setSearchText(searchParams.get('filter_text') || '');
            setFromDate(searchParams.get('filter_from') || moment().startOf('month').format('YYYY-MM-DD'));
            setToDate(searchParams.get('filter_to') || moment().format('YYYY-MM-DD'));
        }
    }, [activeTab, searchParams]);

    const handleChangeSearch = (e) => {
        setShowLoader(true);
        const newSearchText = e.target.value;
        setSearchText(newSearchText);
        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('pageNo', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeFromDate = (val) => {
        setShowLoader(true);
        const formattedDate = val ? format(val, "yyyy-MM-dd") : '';
        setFromDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate) {
            newParams.set('filter_from', formattedDate);
        } else {
            newParams.delete('filter_from');
            newParams.delete('filter_to');
            setToDate('');
        }
        newParams.set('pageNo', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeToDate = (val) => {
        setShowLoader(true);
        const formattedDate = val ? format(val, "yyyy-MM-dd") : '';
        setToDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate) {
            newParams.set('filter_to', formattedDate);
        } else {
            newParams.delete('filter_to');
        }
        newParams.set('pageNo', '1');
        setSearchParams(newParams, { replace: true });
    }

    return (
        <>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Testimonials
                    </MainHeading>
                </div>
                <div className='col-2 col-sm-2 col-md-2 col-lg-2 col-xl-10 col-xxl-9 LevelDiv'>
                    <div className='DurationDiv d-flex align-items-center'>
                        <Label>Date:</Label>
                        <DatePicker
                            onChange={date => { changeFromDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={fromDate ? new Date(moment(fromDate, "YYYY-MM-DD").format('MM-DD-YYYY')) : ''}
                            maxDate={new Date()}
                            popperPlacement={"bottom"}
                            width={'140px'}
                            height={'48px'}
                        />
                        <div className='mx-2'>to</div>
                        <DatePicker
                            disabled={!fromDate}
                            onChange={date => { changeToDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={toDate ? new Date(moment(toDate, "YYYY-MM-DD").format('MM-DD-YYYY')) : ''}
                            minDate={fromDate ? new Date((moment(fromDate, "YYYY-MM-DD").add(1, 'days')).format('MM-DD-YYYY')) : null}
                            maxDate={new Date()}
                            popperPlacement={"bottom"}
                            width={'140px'}
                            height={'48px'}
                        />
                    </div>
                    <div className="separator"></div>

                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            value={searchText}
                            onChange={handleChangeSearch}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </>
    );
}

const TestimonialsTable = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_by_type') || '');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || '');
    const [selected, setSelected] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('pageSize')) || 10);
    const [showLoader, setShowLoader] = useState(false);
    const [viewTestimonialListMainData, setViewTestimonialListMainData] = useState('');
    const viewTestimonialList = useSelector(state => state?.getTestimonialList);
    const viewTestimonialListDataRes = useSelector(state => state?.getTestimonialList?.getTestimonialList);
    const { permission, activeTab } = props;
    const dispatch = useDispatch();

    useEffect(()=>{
        if(!viewTestimonialList.loading)
            setShowLoader(false)
        if(!viewTestimonialList.loading && !viewTestimonialListDataRes?.data?.data && !viewTestimonialList.error){
            setShowLoader(true)
        }
    }, [viewTestimonialList.loading])

    useEffect(() => {
        if (activeTab == tabKeys.reports.TESTIMONIALS) {
            const sendRequest = {
                "pageNo": searchParams.get('pageNo') || 1,
                "pageSize": searchParams.get('pageSize') || 10,
                "filter_text": searchParams.get('filter_text') || '',
                "filter_from": searchParams.get('filter_from') || moment().startOf('month').format('YYYY-MM-DD'),
                "filter_to": searchParams.get('filter_to') || moment().format('YYYY-MM-DD'),
                "order": searchParams.get('order_by_type') || '',
                "orderBy": searchParams.get('order_by') || ''
            };
            dispatch(getTestimonialListAction(sendRequest));
        }else{
          setOrder('');
          setOrderBy('');
          setRowsPerPage(10)
        }
    }, [activeTab, searchParams]);
    
    useEffect(() => {
        if (viewTestimonialList.error !== "Ananda testimonials data does not exists") {
            setViewTestimonialListMainData(viewTestimonialListDataRes && viewTestimonialListDataRes?.data?.data);
        } else {
            setViewTestimonialListMainData('');
        }

    }, [viewTestimonialListDataRes, viewTestimonialList])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order_by_type', newOrder);
        newParams.set('order_by', property);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewTestimonialListDataRes && viewTestimonialListMainData.map((n) => n?.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const handleChangePageNext = () => {
        setShowLoader(true);
        const nextPage = (viewTestimonialListDataRes?.data?.current_page_no || 0) + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('pageNo', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };
    
    const handleChangePagePrev = () => {
        setShowLoader(true);
        const prevPage = (viewTestimonialListDataRes?.data?.current_page_no || 2) - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('pageNo', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true);
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('pageSize', newRowsPerPage.toString());
        newParams.set('pageNo', '1');
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeOption = (e, id, mark_feature) => {
        console.log(permission);
        if (permission === "write") {
            if (e.value === "Approved") {
                viewTestimonialListMainData.find(v => v.testimonial_id === id).status = 'approved';
            } else if (e.value === "Pending") {
                viewTestimonialListMainData.find(v => v.testimonial_id === id).status = 'pending';
            }else{
                viewTestimonialListMainData.find(v => v.testimonial_id === id).status = 'rejected';
            }
            setViewTestimonialListMainData(viewTestimonialListMainData)
            const sendRequest = {
                "mark_feature": mark_feature,
                "id": id,
                "status": e.value === "Approved" ? 'approved' : e.value === "Pending" ? 'pending' : 'rejected'
            };
            dispatch(updateTestimonialStatusAction(sendRequest));
        } else {
            createNotification('warning', "Access Restricted");
        }

    }

    const handleToggleButton = (e, id, status) => {
        if (permission === "write") {
            const sendRequest = {
            "mark_feature": + e.target.checked,
                "id": id,
                "status": status
            };
            dispatch(updateTestimonialStatusAction(sendRequest));
        } else {
            createNotification('warning', "Access Restricted");
        }
    }

    return (
      <Box sx={{ width: '100%' }} className="TestimonialBox h-100">
      <Paper  className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
              <EnhancedTableToolbar numSelected={selected.length}
                  showLoader={showLoader}
                  setShowLoader={setShowLoader}
                  rowsPerPageNos={rowsPerPage} 
                  activeTab ={activeTab} />
          {
              showLoader ?
              <div className='w-100 text-center py-5'>
                  <CircularProgress sx={{'color': '#74613C'}}/>
              </div>
              :
              <>
                  
                  {viewTestimonialListMainData ? <TableContainer sx={{ pt: 0, pr: 3, pb: 3, pl: 3, height: '100%' }}>
                      <Table
                          sx={{ minWidth: 750 }}
                          aria-labelledby="tableTitle"
                          stickyHeader
                          size='small'
                      >
                          <EnhancedTableHead
                              numSelected={selected.length}
                              order={order}
                              orderBy={orderBy}
                              onSelectAllClick={handleSelectAllClick}
                              onRequestSort={handleRequestSort}
                              rowCount={viewTestimonialListDataRes && viewTestimonialListMainData?.length}
                          />
                          <TableBody>
                              {
                                  viewTestimonialListDataRes && stableSort(viewTestimonialListMainData, getComparator(order, orderBy))
                                      .map((row, index) => {
                                          const labelId = `enhanced-table-checkbox-${index}`;
                                          return (
                                              <React.Fragment key={index}>
                                                  <TableRow hover onClick={(event) => handleClick(event, row.program_title)} role="checkbox"

                                                      tabIndex={-1}
                                                      key={index}

                                                      >
                                                      <TableCell component="th" id={labelId} scope="row" padding="none" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA" }}>{row.program_title}</TableCell>
                                                      <TableCell align="left" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA" }}>{row.guest_name}</TableCell>
                                                      <TableCell align="left" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA" }}> 
                                                      {row.check_in ? moment(row.check_in).format('DD/MM/YYYY'): ''} - {row.check_out ? moment(row.check_out).format('DD/MM/YYYY'): ''}
                                                      </TableCell>
                                                      <TableCell align="left" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA" }}>{row.submitted_on && moment(row.submitted_on).format('DD/MM/YYYY')}</TableCell>

                                                      <TableCell align="left" width="10px" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA" }}

                                                      >
                                                          <Select
                                                              className="react-select status-select"
                                                              classNamePrefix="react-select"
                                                              onChange={(e) => { handleChangeOption(e, row.testimonial_id, row.mark_feature) }}
                                                              value={row.status === 'approved' ? { label: "Approved", value: "Approved" } : row.status === 'rejected' ? { label: "Rejected", value: "Rejected" } : { label: "Pending", value: "Pending" }}
                                                              options={testimonialsoptions}
                                                              menuPlacement="auto"
                                                            menuPosition="absolute"   
                                                            menuPortalTarget={null}
                                                              isSearchable={false}
                                                              theme={(theme) => ({
                                                                  ...theme,
                                                                  isFocused: "#74613C",
                                                                  colors: {
                                                                      ...theme.colors,
                                                                      primary25: '#F5F5F5',
                                                                      primary: '#f6f4f0',
                                                                  },
                                                              })}
                                                              getOptionLabel={(row) => (
                                                                  <>
                                                                  <span className={row.label === "Approved" ? "ApprovedClass" : row.label === "Pending" ? "PendingClass" :"RejectedClass"}
                                                                  >
                                                                      {row.label}
                                                                  </span>
                                                                  </>
                                                              )}
                                                          />
                                                      </TableCell>

                                                      <TableCell align="left" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA" }}>
                                                          <Switch  inputProps={{ 'aria-label': 'Color switch demo' }} disabled={permission !== "write"} defaultChecked={!!row.mark_feature} onChange={(e) => { handleToggleButton(e, row.testimonial_id, row.status) }} />
                                                      </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                      <TableCell align="left" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA", px:0,  py:3}} colSpan={6}>
                                                          DETAILS: {row.details}
                                                          {/* <ReadMore text={`DETAILS: ${row.details}`}  />  */}
                                                      </TableCell>
                                                  </TableRow>
                                              </React.Fragment>
                                          );
                                      })}
                          </TableBody>
                      </Table>
                  </TableContainer>
                  : <div className='text-center w-100 text-muted mt-3'>No Records</div>}
              </>
          }
          </Paper>
          {
              viewTestimonialListMainData
              &&
              <div className='paginationBlock'>
                  <div className='textData'><p>Items per page: </p></div>
                  <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                      <Select
                          placeholder={rowsPerPage}
                          className="react-select"
                          classNamePrefix="react-select"
                          value={rowsPerPage}
                          options={rowOptions}
                          isSearchable={false}
                          onChange={handleChangeRowsPerPage}
                          theme={(theme) => ({
                              ...theme,
                              colors: {
                                  ...theme.colors,
                                  primary25: '#F5F5F5',
                                  primary: '#74613C',
                              },
                          })}
                          menuPlacement="top"
                          menuPosition="fixed"
                          styles={{
                              menu: (base) => ({
                                  ...base,
                                  top: 'auto',
                                  bottom: 0,
                              }),
                          }}
                      />
                  </FormGroup>
                  {viewTestimonialListDataRes?.data && <p className='endText'>   {viewTestimonialListDataRes?.data?.start} - {viewTestimonialListDataRes?.data?.end} of {viewTestimonialListDataRes?.data?.total}</p>}
                  <p>                         
                    <button className={`btnPrev ${viewTestimonialListDataRes?.data?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={viewTestimonialListDataRes?.data?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                        <ArrowBackIosNewSharpIcon className='iconBtn' />
                    </button> 
                    <button className={`btnPrev ${viewTestimonialListDataRes?.data?.current_page_no === viewTestimonialListDataRes?.data?.total_pages ? "opacityBtns" : ''}`} disabled={viewTestimonialListDataRes?.data?.current_page_no === viewTestimonialListDataRes?.data?.total_pages} onClick={() => { handleChangePageNext() }}>
                        <ArrowForwardIosSharpIcon className='iconBtn' />
                    </button></p>
              </div>   
          }
      </Box>
    );
}
export default TestimonialsTable;